import { render, staticRenderFns } from "./BarItem.vue?vue&type=template&id=138d1992&scoped=true"
import script from "./BarItem.vue?vue&type=script&lang=js"
export * from "./BarItem.vue?vue&type=script&lang=js"
import style0 from "./BarItem.vue?vue&type=style&index=0&id=138d1992&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138d1992",
  null
  
)

export default component.exports